import { createAsyncThunk } from '@reduxjs/toolkit';
import { postUpdateProjectBankFilePermission } from 'scenes/ProjectBank/services/postUpdateProjectBankFilePermission.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

/**
 * Thunk to update a project bank item (file or folder).
 * @param {string} filePermissionId - The ID of the item to update.
 * @param {Object} updates - The updates to apply to the item.
 */
export const updateProjectBankItem = createAsyncThunk(
    'projectBank/updateProjectBankItem',
    async ({ filePermissionId, updates }, { getState, rejectWithValue }) => {

        try {
            const state = getState();

            const projectId = selectSelectedProjectId(state);

            const updatedFilePermission = await postUpdateProjectBankFilePermission(
                { filePermissionId, updates },
                projectId
            );

            return updatedFilePermission;

        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
